import { Breadcrumb, BreadcrumbItem } from '@common/components/Breadcrumb'
import { StudySubjectViewSchema, SubjectStatus } from '@common/config/api/client'
import SubjectStatusChip from '@features/subject/components/SubjectsTimepointsTable/SubjectStatusChip'
import { Box, Button, Stack, Typography } from '@mui/material'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import { SPACING } from '@common/theme/spacing'
import { LowPriority } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import { generatePathWithParams } from '@common/utils/urlUtils'
import { ROUTES } from 'src/routes'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { QueryPermission, TimepointPermission } from '@auth/permissionsEnum'
import { Fragment } from 'react/jsx-runtime'
import { useState } from 'react'
import SubjectReassignModal from '@features/qc_task_details_view/pages/modals/SubjectReassignModal'

export interface SubjectDetailsHeaderProps {
  breadcrumbs: BreadcrumbItem[]
  subject: StudySubjectViewSchema | undefined
}

const SubjectDetailsHeader = ({ breadcrumbs, subject }: SubjectDetailsHeaderProps) => {
  const [openReassignModal, setOpenReassignModal] = useState(false)
  const { studyId, subjectId } = useParams<{ studyId: string; subjectId: string }>()
  const navigate = useNavigate()
  const { hasPermission } = useCombinedPermissions()
  const handleCreateQuery = () => {
    if (studyId && subjectId) {
      const queriesPath = generatePathWithParams(ROUTES.SUBJECT_QUERIES.path, { studyId, subjectId })
      navigate(queriesPath, {
        state: { openCreateQueryDrawer: true },
      })
    }
  }
  return (
    <Fragment>
      <Stack sx={{ mb: SPACING.headerSpacingY }} direction="row" justifyContent="space-between" alignItems="flex-start">
        <Stack>
          <Breadcrumb items={breadcrumbs} />
          <Box display="flex" mt={2} alignItems="center" gap={2}>
            <Typography variant="h4">Subject {subject?.pseudo_id}</Typography>
            <SubjectStatusChip subjectStatus={subject?.status as SubjectStatus} />
          </Box>
          <Box display="flex" mt={1} alignItems="center" gap={1}>
            <CalendarMonthRoundedIcon sx={{ color: 'text.secondary' }} fontSize="small" />
            <Typography variant="body1" color="text.secondary">
              First visit:
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" gap={SPACING.buttonSpacing}>
          {hasPermission(QueryPermission.CREATE) && (
            <Button color="secondary" variant="contained" onClick={handleCreateQuery}>
              Create query
            </Button>
          )}
          {(hasPermission(TimepointPermission.ALL) || hasPermission(TimepointPermission.REASSIGN_EXAM)) && (
            <Button
              color="secondary"
              variant="contained"
              startIcon={<LowPriority />}
              onClick={() => setOpenReassignModal(true)}
            >
              Reassign data
            </Button>
          )}
        </Stack>
      </Stack>
      <SubjectReassignModal open={openReassignModal} onClose={() => setOpenReassignModal(false)} />
    </Fragment>
  )
}

export default SubjectDetailsHeader
